import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import ActionButton from './ActionButton';
import Drawer from './Drawer';

export interface FilterDrawerProps {
  open: boolean;
  title?: string;
  applyText?: string;
  clearText?: string;
  onApply: () => void;
  onClear: () => void;
  onClose: () => void;
  width?: number;
  children: ReactNode;
}

const FilterDrawer: React.FC<FilterDrawerProps> = ({
  open,
  title = 'Filters',
  applyText = 'Apply',
  clearText = 'Clear all',
  onApply,
  onClear,
  onClose,
  width = 320,
  children,
}) => {
  const handleApply = () => {
    onApply();
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      width={width}
      footer={
        <Box sx={{ display: 'flex', gap: 1 }}>
          <ActionButton variant="outline" fullWidth onClick={onClear}>
            {clearText}
          </ActionButton>
          <ActionButton variant="primary" fullWidth onClick={handleApply}>
            {applyText}
          </ActionButton>
        </Box>
      }
    >
      {children}
    </Drawer>
  );
};

export default FilterDrawer;
